import http from "../tools/http";

export default {
  getOne() {
    return http.get("/profile");
  },
  update(data) {
    return http.patch("/profile", data);
  },
  updateSettings(data) {
    return http.patch("/profile/settings", data);
  },
  updatePassword(data) {
    return http.patch("/profile/password", data);
  },
  getRegistrationEmail(token) {
    return http.get("/finish-registration/" + token);
  },
  finishRegistration({ token, data }) {
    return http.post("/finish-registration/" + token, data);
  },
  recovery(email) {
    return http.post("/password-recovery", { email });
  },
  reset(data) {
    return http.post("/password-reset", data);
  }
};
